import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <motion.footer
      className="relative z-10 mt-16 border-t border-white/10"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.4 }}
    >
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2 text-white/30 text-xs">
            <svg viewBox="0 0 22 28" className="w-3.5 h-4 opacity-40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1h14l5 5v21H1V1z" stroke="white" strokeWidth="1.2" strokeLinejoin="round" opacity="0.25"/>
              <path d="M15 1v5h5" stroke="white" strokeWidth="1.2" strokeLinejoin="round" opacity="0.15"/>
              <line x1="4" y1="8" x2="16" y2="8" stroke="white" strokeWidth="1" strokeLinecap="round" opacity="0.18"/>
              <line x1="4" y1="11" x2="13" y2="11" stroke="white" strokeWidth="1" strokeLinecap="round" opacity="0.12"/>
              <g stroke="#FDE047" strokeWidth="0.6" opacity="0.3">
                <line x1="6" y1="17" x2="11" y2="19"/>
                <line x1="11" y1="19" x2="16" y2="17"/>
                <line x1="11" y1="19" x2="8" y2="23"/>
                <line x1="11" y1="19" x2="14.5" y2="23"/>
              </g>
              <circle cx="6" cy="17" r="1.3" fill="#FDE047"/>
              <circle cx="11" cy="19" r="1.6" fill="#FDE047"/>
              <circle cx="16" cy="17" r="1.1" fill="#FDE047"/>
              <circle cx="8" cy="23" r="1.3" fill="#FDE047"/>
              <circle cx="14.5" cy="23" r="1.1" fill="#FDE047"/>
            </svg>
            <span className="font-semibold text-white/40">paperdigest</span>
            <span className="text-white/20">|</span>
            <span>&copy; {new Date().getFullYear()}</span>
          </div>
          <div className="flex items-center gap-1 text-xs">
            <Link
              to="/privacy-policy"
              className="text-white/30 hover:text-white/70 transition-colors duration-200 px-2 py-1"
            >
              Privacy
            </Link>
            <span className="text-white/15">/</span>
            <Link
              to="/terms-of-service"
              className="text-white/30 hover:text-white/70 transition-colors duration-200 px-2 py-1"
            >
              Terms
            </Link>
          </div>
        </div>
      </div>
    </motion.footer>
  );
}

export default Footer;
